import React from 'react';
import { Content } from '../../../common/TabsStyled';
import Activities from './activities';
import Conferences from './conferences';
import Inscriptions from './inscriptions';
import Workshops from './workshops';

interface TabContentProps {
  current: number;
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number, typeEvent: string) => void;
  setCounterSubscriptions: (counterSubscriptions: number) => void;
}
const TabContent = (props: TabContentProps) => {
  const { current, handleTab, selectEvent, setCounterSubscriptions } = props;
  switch (current) {
    case 2:
      return (
        <Content className="content active-content">
          <Workshops
            current={current}
            handleTab={handleTab}
            selectEvent={selectEvent}
            tabTitle={'Talleres'}
          />
        </Content>
      );
    case 3:
      return (
        <Content className="content active-content">
          <Conferences
            current={current}
            handleTab={handleTab}
            selectEvent={selectEvent}
            tabTitle={'Conferencias'}
          />
        </Content>
      );
    case 4:
      return (
        <Content className="content active-content">
          <Activities
            current={current}
            handleTab={handleTab}
            selectEvent={selectEvent}
            tabTitle={'Actividades'}
          />
        </Content>
      );
    case 1:
    default:
      return (
        <Content className="content active-content">
          <Inscriptions
            current={current}
            handleTab={handleTab}
            selectEvent={selectEvent}
            tabTitle={'Inscritos'}
            setCounterSubscriptions={setCounterSubscriptions}
          />
        </Content>
      );
  }
};

export default TabContent;
